import { Container, Skeleton } from "@/components/atoms";
import { ProductCard } from "@/components/molecules";
import { useProducts } from "@/hooks/use-products";
import { relatedProducts } from "@/lib/product-helpers";
import type { Product } from "@/types";

export function RelatedProducts({ product }: { product: Product }) {
  const { data: products, isLoading } = useProducts();
  const related = relatedProducts(products ?? [], product, 3);

  /* CLS — this returned `null` while useProducts() was in flight and then popped a full heading +
     product grid in from zero height. Reserve it while we do not yet know; still collapse once we
     KNOW there is nothing related, which is the honest empty state rather than a permanent hole. */
  if (isLoading) {
    return (
      <Container className="py-12">
        <Skeleton className="mb-6 h-8 w-64" />
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
          {Array.from({ length: 3 }, (_, i) => (
            <Skeleton key={i} className="aspect-[3/4] w-full" />
          ))}
        </div>
      </Container>
    );
  }
  if (!related.length) return null;
  return (
    <Container className="py-12">
      <h2 className="mb-6 font-condensed text-2xl font-bold text-night-blue">
        You might also like
      </h2>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
        {related.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>
    </Container>
  );
}
